class Carousel extends HTMLElement {
  constructor() {
    super();

    if (this.getAttribute("data-slider-async")) {
      document.addEventListener("asyncSlider:ready", () => {
        this.init();
      });
    } else {
      this.init();
    }
  }

  init() {
    this.playPauseState = "paused";
    this.interval;
    this.currentPage = 1;
    this.productSlider =
      this.getAttribute("data-product-slider") == "true" ? true : false;
    this.productMedia = document.querySelector(".js-product-media");
    this.slider = this.querySelector(".js-carousel-slider");
    this.vertical =
      this.getAttribute("data-slider-vertical") == "true" ? true : false;
    this.verticalDesktop =
      this.getAttribute("data-slider-vertical-desktop") == "true"
        ? true
        : false;
    this.mq = [
      window.matchMedia("(min-width: 1201px)"),
      window.matchMedia("(min-width: 500px) and (max-width: 989px)"),
    ];
    this.enableSliderLooping =
      this.getAttribute("data-slider-looping") == "true" ? true : false;
    this.enableSliderAutoplay =
      this.getAttribute("data-slider-autoplay") == "true" ? true : false;

    if (
      Shopify.designMode &&
      this.dataset.disableLoopingInCustomizer === "true"
    ) {
      this.enableSliderAutoplay = false;
    }

    this.playPause = this.querySelector(".js-carousel-play-pause");
    this.autoplaySpeed = this.getAttribute("data-slider-autoplay-speed")
      ? parseFloat(this.getAttribute("data-slider-autoplay-speed"))
      : 3000;
    this.prevButton = this.querySelectorAll('button[name="previous"]');
    this.nextButton = this.querySelectorAll('button[name="next"]');

    this.linkedPrevButton = document.querySelectorAll(
      `.js-carousel-linked-prev-button[data-linked-carousel="${this.id}"]`
    );
    this.linkedNextButton = document.querySelectorAll(
      `.js-carousel-linked-next-button[data-linked-carousel="${this.id}"]`
    );

    this.sidebars = this.querySelectorAll(".js-carousel-sidebar-item");

    if (this.linkedPrevButton) {
      this.prevButton = [...this.prevButton, ...this.linkedPrevButton];
    }

    if (this.linkedNextButton) {
      this.nextButton = [...this.nextButton, ...this.linkedNextButton];
    }

    this.tracker = this.querySelector(".js-carousel-tracker");
    this.currentTracker = 1;

    this.thumbSlider = this.getAttribute("data-slider-thumb")
      ? document.getElementById(this.getAttribute("data-slider-thumb"))
      : null;
    this.fullSlides =
      this.getAttribute("data-slider-items") == "1" ? true : false;
    this.delayInit =
      this.getAttribute("data-delay-init") == "true" ? true : false;

    if (this.enableSliderAutoplay) {
      this.playPauseState = "playing";
    }

    if (!this.slider) return;

    if (this.delayInit) {
      this.addEventListener("trigger-init", () => {
        this.initPages();
      });
    } else {
      this.initPages();
    }

    const resizeObserver = new ResizeObserver((entries) => {
      this.resizeHandler();
    });
    resizeObserver.observe(this.slider);

    this.addEventListener("slider:go", (e) => {
      const index = e.detail.index;
      const skipCheck = e.detail.skipCheck ? e.detail.skipCheck : false;
      const skipAnimation = e.detail.skipAnimation ? e.detail.skipAnimation : false;

      if (!index) return;

      this.scrollToSlide(index, skipCheck, skipAnimation);

      if (e.detail.showSlider) {
        this.classList.remove("carousel--hidden");
      }
    });

    if (this.playPause) {
      this.playPause.addEventListener("click", this.togglePlayPause.bind(this));
    }

    if (this.dataset.gestureScroll) this.gestureScroll();

    this.infiniteScroll = this.dataset.infiniteScroll == "true";
    this.jumpVisibleSlides = this.dataset.jumpVisibleSlides == "true";

    this.watchVisibleSlides();

    if (this.getVisibleSlides().length > 1) {
      this.handleInfiniteScroll("prev");
    }
  }

  watchVisibleSlides() {
    const observerCallback = (entries, observer) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle("slide-visible", entry.isIntersecting);
        if (!entry.isIntersecting || !this.tracker) return;
        this.currentTracker = entry.target.dataset.originalIndex;
        this.updateTracker();
      });
    };
    const observer = new IntersectionObserver(observerCallback, {threshold: 0.5});
    
    [...this.sliderItems].forEach(item => {
      observer.observe(item);
    });
  }

  getVisibleSlides() {
    return [...this.sliderItems].filter((slide) => {
      return slide.classList.contains("slide-visible");
    });
  }

  gestureScroll() {
    let browserIsFirefox = !!(navigator.userAgent.toLowerCase().indexOf("firefox") > -1);

    let canTriggerScroll = true;
    let scrollDelta = 0;
    const scrollThreshold = 100;

    this.slider.addEventListener("wheel", (event) => {
      if (event.wheelDeltaX != 0) event.preventDefault();

      // Prevents horizontal scrolling error caused by magic mouse
      if (browserIsFirefox) {
        event.preventDefault();
        window.scrollBy(0, event.deltaY);
        return;
      }

      scrollDelta += event.deltaX;

      if (Math.abs(scrollDelta) >= scrollThreshold) {
        if (!canTriggerScroll) return (scrollDelta = 0);

        clearInterval(this.interval);

        const name = scrollDelta > 0 ? "next" : "previous";
        this.onButtonClick({ currentTarget: { name } }, true);

        canTriggerScroll = false;
        setTimeout(() => {
          canTriggerScroll = true;
        }, 1000);

        scrollDelta = 0;
      }
    });
  }

  pause() {
    this.playPause.classList.remove("carousel__play-pause--pause");
      this.playPause.classList.add("carousel__play-pause--play");
      this.classList.add("carousel__paused");
      this.playPauseState = "paused";
      clearInterval(this.interval);
  }
  togglePlayPause() {
    if (this.playPause.classList.contains("carousel__play-pause--pause")) {
      this.pause();
    } else if (
      this.playPause.classList.contains("carousel__play-pause--play")
    ) {
      this.playPause.classList.remove("carousel__play-pause--play");
      this.playPause.classList.add("carousel__play-pause--pause");
      this.classList.remove("carousel__paused");
      this.playPauseState = "playing";
      this.autoplay();
    }
  }

  isVertical() {
    if (this.vertical && this.verticalDesktop) {
      return this.mq.some((mq) => mq.matches);
    } else {
      return this.vertical;
    }
  }

  initPages() {    
    this.sliderItems = [...this.querySelectorAll(".js-carousel-slide")];

    this.slider.addEventListener(
      "scroll",
      debounce(this.update.bind(this), 100)
    );

    this.prevButton.forEach((el) => {
      el.addEventListener("click", this.onButtonClick.bind(this));
    });

    this.nextButton.forEach((el) => {
      el.addEventListener("click", this.onButtonClick.bind(this));
    });

    if (this.enableSliderAutoplay && this.playPauseState === "playing")
      this.autoplay();

    if (this.getAttribute("data-slider-for")) {
        this.mainSlider = document.getElementById(
        this.getAttribute("data-slider-for")
      );
      this.sliderItems.forEach((slide) => {
        slide.addEventListener("click", () => {
          this.sliderItems.forEach((slide) => {
            slide.classList.remove("active");
          });
          this.mainSlider.scrollToSlide(this.sliderItems.indexOf(slide) + 1);
          slide.classList.add('active');
        });
      });
    }

    if (this.tracker) {
      this.initTracker();
    }

    this.resizeHandler();
  }

  resizeHandler() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );

    if (this.sliderItemsToShow[1] && this.sliderItemsToShow[0]) {
      this.sliderItemOffset =
        this.sliderItemsToShow[1].offsetLeft -
        this.sliderItemsToShow[0].offsetLeft;

      if (this.isVertical()) {
        this.sliderItemOffset =
          this.sliderItemsToShow[1].offsetTop -
          this.sliderItemsToShow[0].offsetTop;
      }

      this.slidesPerPage =
        Math.floor(this.slider.clientWidth / this.sliderItemOffset) + 1;

      if (this.classList.contains("carousel--show-to-edge")) {
        this.slidesPerPage -= 1;
      }
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    }
  }

  update() {
    if (!this.keepCurrentPageSet) {
      this.currentPage =
        Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

      if (this.isVertical()) {
        this.currentPage =
          Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1;
      }
    }
    this.keepCurrentPageSet = false;

    let currentSlide = this.currentPage;

    this.sliderItemsToShow.forEach((item, index) => {
      let thisSlide = index + 1;
      if (this.isSlideVisible(item) && thisSlide < currentSlide) {
        currentSlide = thisSlide;
      }
    });
    if (!this.enableSliderLooping && !this.infiniteScroll) {
      this.prevButton.forEach((el) => {
        if (this.isSlideVisible(this.sliderItemsToShow[0])) {
          el.setAttribute("disabled", "disabled");
        } else {
          el.removeAttribute("disabled");
        }
      });

      this.nextButton.forEach((el) => {
        if (
          this.isSlideVisible(
            this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
          )
        ) {
          el.setAttribute("disabled", "disabled");
        } else {
          el.removeAttribute("disabled");
        }
      });
    }

    if (this.tracker) {
      this.updateTracker(this.currentPage);
    }

    if (this.thumbSlider) {
      this.updateThumb(this.currentPage);
    }

    this.updateActiveSlide(this.currentPage);

    window.pauseMedia(this);

    if (this.classList.contains("carousel-main")) {
      var siblingElement = this.nextElementSibling;
      if (siblingElement) {
        if (siblingElement.classList.contains("carousel-thumb")) {
          var thumbSlides =
            siblingElement.querySelectorAll(".js-carousel-slide");
          if (thumbSlides) {
            thumbSlides.forEach((thumbSlide) => {
              thumbSlide.classList.remove("active");
              var thumbSlideIndex = thumbSlide.dataset.slideIndex;
              if (thumbSlideIndex == currentSlide) {
                thumbSlide.classList.add("active");
              }
            });
          }
        }
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    if (element) {
      let lastVisibleSlide = Math.ceil(
        this.slider.clientWidth + this.slider.scrollLeft - offset
      );

      if (this.isVertical()) {
        lastVisibleSlide = Math.ceil(
          this.slider.clientHeight + this.slider.scrollTop - offset
        );
      }

      if (this.isVertical()) {
        return (
          Math.floor(element.offsetTop + element.clientHeight) <=
            lastVisibleSlide &&
          Math.floor(element.offsetTop) >= Math.floor(this.slider.scrollTop)
        );
      }

      return (
        Math.floor(element.offsetLeft + element.clientWidth) <=
          lastVisibleSlide &&
        Math.floor(element.offsetLeft) >= Math.floor(this.slider.scrollLeft)
      );
    }
  }

  updateActiveSlide(slide) {
    this.lastSlideActive = false;

    if (this.productMedia) {
      this.productMedia.classList.remove("product__media--hide-labels");
    }

    this.sliderItems.forEach((el) => {
      el.classList.remove("active");
    });

    const index = slide - 1;
    const activeSlide = this.sliderItems[index];

    if (!activeSlide) return;

    activeSlide.classList.add("active");

    this.sidebars.forEach((el) => {
      el.classList.remove("active");

      if (el.getAttribute("data-sidebar-item-index") == index) {
        el.classList.add("active");
      }
    });

    const slideMedia = activeSlide.querySelectorAll(
      "video, iframe, model-viewer"
    );

    if (!slideMedia.length) return;

    if (this.productMedia) {
      this.productMedia.classList.add("product__media--hide-labels");
    }
  }

  initTracker() {
    //init dots if element is present in the carousel
    //dots are outputted per slide but then hidden as there might be multiple items per slide
    const allParts = this.tracker.querySelectorAll("div");
    allParts.forEach((part) => {
      part.addEventListener("click", () => {
        const index = part.getAttribute("data-slide-index");

        if (index) this.scrollToSlide(index);
      });
    });
  }

  updateTracker() {
   // updates active part to display which slide is visible
    const allParts = this.tracker.querySelectorAll("div");

    allParts.forEach((part) => {
      part.classList.remove("active");
    });

    if (allParts[this.currentTracker - 1]) {
      allParts[this.currentTracker - 1].classList.add("active");
    }
  }

  updateThumb(slide) {
    const thumbSlides = this.thumbSlider.querySelectorAll(".js-carousel-slide");
    if (thumbSlides.length) {
      for (let index = 0; index < thumbSlides.length; index++) {
        let slideNumber = slide - 1;
        if (index == slideNumber) {
          thumbSlides[index].classList.add("active");
        } else {
          thumbSlides[index].classList.remove("active");
        }
      }

      if (typeof this.thumbSlider.scrollToSlide == "undefined") return;
      this.thumbSlider.scrollToSlide(slide);
    }
  }

  scrollToSlide(slide, skipCheck, skipAnimation) {
    this.resetInfiniteSlides();

    requestAnimationFrame(() => {
      this.currentTracker = slide;
      clearInterval(this.interval);

      //check if slide is in view, if not, scroll to it
      if (!this.isSlideVisible(this.sliderItemsToShow[slide - 1]) || skipCheck) {

        // find the slide with data-slide-index=slide
        const targetSlide = this.slider.querySelector(`.js-carousel-slide[data-slide-index="${slide}"]`);
        if( targetSlide ) {
          // Get scroll position of the target slide
          this.slideScrollPosition = targetSlide.offsetLeft;
        } else {
          this.slideScrollPosition = (slide - 1) * this.sliderItemOffset;
        }

        if (this.isVertical()) {
          this.slider.scrollTo({
            top: this.slideScrollPosition,
            behavior: skipAnimation ? "instant" : "auto",
          });
        } else {
          this.slider.scrollTo({
            left: this.slideScrollPosition,
            behavior: skipAnimation ? "instant" : "auto",
          });
        }

        this.slider.dispatchEvent(new Event("scroll"));
      }

      this.pause();
      
    })
  }

  handleInfiniteScroll(direction) {
    const slidesToMove = this.jumpVisibleSlides
      ? this.getVisibleSlides().length
      : 1;

    let startSlideIndex = 1;
    let endSlideIndex = this.sliderItems.length;

    if (this.jumpVisibleSlides) {
      startSlideIndex = slidesToMove + 1;
      endSlideIndex = this.sliderItems.length - slidesToMove * 2;
    }

    const initSlide = (slide) => {
      this.sliderItems.forEach((slide) => {
        slide.classList.remove("active");
      });
      slide.classList.add("active");
    };

    if (this.currentPage >= endSlideIndex && direction === "next") {
      for (let i = 1; i <= slidesToMove; i++) {
        const targetSlide = this.slider.querySelector(
          ".js-carousel-slide:first-child"
        );
        this.slider.removeChild(targetSlide);
        this.slider.appendChild(targetSlide);
        if (i === slidesToMove) initSlide(targetSlide);

        this.slider.scrollTo({
          left: this.slideScrollPosition - (slidesToMove * (this.sliderItemOffset * 2)),
          behavior: 'instant'
        });

        this.slideScrollPosition = this.slideScrollPosition - (slidesToMove * this.sliderItemOffset);
      }
      this.keepCurrentPageSet = true;
    } else if (!(this.currentPage > startSlideIndex) && direction === 'previous') {
      for (let i = 1; i <= slidesToMove; i++) {
        const targetSlide = this.slider.querySelector('.js-carousel-slide:last-child');
        this.slider.removeChild(targetSlide);
        this.slider.insertBefore(targetSlide, this.slider.firstChild);
        if (i === slidesToMove) initSlide(targetSlide);
        
        this.slider.scrollTo({
          left: slidesToMove * this.sliderItemOffset,
          behavior: 'instant'
        });

        this.slideScrollPosition = 0;
      }
      this.keepCurrentPageSet = true;
    }
  }

  resetInfiniteSlides() {
    const slides = this.querySelectorAll(".js-carousel-slide");
    const firstSlide = slides[0];
    const originalIndex = parseFloat(
      firstSlide.getAttribute("data-original-index")
    );

    if (originalIndex == 2) {
      const targetSlide = this.slider.querySelector(
        ".js-carousel-slide:last-child"
      );
      this.slider.removeChild(targetSlide);
      this.slider.insertBefore(targetSlide, this.slider.firstChild);
    } else if (originalIndex == 4) {
      const targetSlide = this.slider.querySelector(
        ".js-carousel-slide:first-child"
      );
      this.slider.removeChild(targetSlide);
      this.slider.appendChild(targetSlide);
    }
  }

  onButtonClick(event, autoplay = false) {
    clearInterval(this.interval);

    if (!autoplay) {
      event.preventDefault();
    }

    const step = this.jumpVisibleSlides
      ? this.getVisibleSlides().length
      : event?.currentTarget?.dataset?.step || 1;

    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;

    if (this.isVertical()) {
      this.slideScrollPosition =
        event.currentTarget.name === "next"
          ? this.slider.scrollTop + step * this.sliderItemOffset
          : this.slider.scrollTop - step * this.sliderItemOffset;
    }

    if (this.infiniteScroll) {
      this.handleInfiniteScroll(event.currentTarget.name);
    }

    const currentTarget = event.currentTarget;

    setTimeout(() => {
      if (
        this.currentPage == 1 &&
        currentTarget.name == "previous" &&
        this.enableSliderLooping &&
        !this.infiniteScroll
      ) {
        if (this.isVertical()) {
          this.slider.scrollTo({
            top: this.sliderItemsToShow.length * this.sliderItemOffset,
          });
        } else {
          this.slider.scrollTo({
            left: this.sliderItemsToShow.length * this.sliderItemOffset,
          });
        }
      } else if (
        this.isSlideVisible(
          this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
        ) &&
        currentTarget.name == "next" &&
        this.enableSliderLooping &&
        !this.infiniteScroll
      ) {
        if (this.isVertical()) {
          this.slider.scrollTo({
            top: 0,
          });
        } else {
          this.slider.scrollTo({
            left: 0,
          });
        }
      } else {
        if (this.isVertical()) {
          this.slider.scrollTo({
            top: this.slideScrollPosition,
          });
        } else {
          this.slider.scrollTo({
            left: this.slideScrollPosition,
          });
        }
      }
      this.slider.dispatchEvent(new Event("scroll"));

      if (this.enableSliderAutoplay && this.playPauseState === "playing") {
        clearInterval(this.interval);
        this.autoplay();
      }
    }, 1);
  }

  updateTopSlide(topSlideIndex) {
    this.sliderItems.forEach((slide, index) => {
      slide.classList.toggle("top-slide", index === topSlideIndex);
    });
  }

  autoplay() {
    this.interval = setInterval(() => {
      this.onButtonClick(
        {
          currentTarget: {
            name: "next",
          },
        },
        true
      );
    }, this.autoplaySpeed);
  }
}

customElements.define("carousel-slider", Carousel);

class SwiperCarousel extends HTMLElement {
  constructor() {
    super();
    const swiperEl = this.querySelector('swiper-container');

    const swiperParams = {
      effect: "coverflow",
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: "auto",
      centeredSlides: true,
      initialSlide: 2,
      loop: true,
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 3,
        initialSlide: 3,
        slideShadows: true
      }
    };

    const buttonPrev = this.querySelector('.swiper-carousel--prev');
    const buttonNext = this.querySelector('.swiper-carousel--next');

    buttonPrev.addEventListener('click', () => swiperEl.swiper.slidePrev());
    buttonNext.addEventListener('click', () => swiperEl.swiper.slideNext());

    Object.assign(swiperEl, swiperParams);
    swiperEl.initialize();
  }
}

customElements.define("swiper-carousel", SwiperCarousel);